import { Comparable } from "@siteimprove/alfa-comparable";
import { Real } from "@siteimprove/alfa-math";
import { Numeric as BaseNumeric } from "../../calculation/numeric/index.js";
import { Value } from "../value.js";
/**
 * @public
 */
export var Numeric;
(function (Numeric) {
    /**
     * Numerics that are the result of a calculation.
     */
    class Calculated extends Value {
        _math;
        constructor(math, type) {
            super(type, true);
            this._math = math;
        }
        get math() {
            return this._math;
        }
        hasCalculation() {
            return true;
        }
        equals(value) {
            return value instanceof Calculated && value._math.equals(this._math);
        }
        hash(hash) {
            this._math.hash(hash);
        }
        toJSON() {
            return { ...super.toJSON(), math: this._math.toJSON() };
        }
        toString() {
            return this._math.toString();
        }
    }
    Numeric.Calculated = Calculated;
    /**
     * Numerics that are a fixed (not calculated) value.
     */
    class Fixed extends Value {
        _value;
        constructor(value, type) {
            super(type, false);
            this._value = Real.round(value, BaseNumeric.Decimals);
        }
        get value() {
            return this._value;
        }
        hasCalculation() {
            return false;
        }
        isZero() {
            return this._value === 0;
        }
        equals(value) {
            return value instanceof Fixed && value._value === this._value;
        }
        compare(value) {
            return Comparable.compareNumber(this._value, value._value);
        }
        hash(hash) {
            hash.writeFloat64(this._value);
        }
        toJSON() {
            return {
                ...super.toJSON(),
                value: this._value,
            };
        }
        toString() {
            return `${this._value}`;
        }
    }
    Numeric.Fixed = Fixed;
    function isCalculated(value) {
        return value instanceof Calculated;
    }
    Numeric.isCalculated = isCalculated;
    function isFixed(value) {
        return value instanceof Fixed;
    }
    Numeric.isFixed = isFixed;
    function isNumeric(value) {
        return value instanceof Calculated || value instanceof Fixed;
    }
    Numeric.isNumeric = isNumeric;
    // Curryfied version is more convenient for monadic call sites.
    function isZero(value) {
        return value.isZero();
    }
    Numeric.isZero = isZero;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=numeric.js.map